(function(){
  if (window.__bvHomeHotfix) return;
  window.__bvHomeHotfix = true;

  var el;

  function debounce(fn, wait){
    var t;
    return function(){
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  function init(){
    el = document.getElementById('MobileSearchInput');
    if (!el) return setTimeout(init, 300);

    // Stop other input handlers first, then re-fire once on a delay
    var relay = debounce(function(){
      el.removeEventListener('input', block, true);
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.addEventListener('input', block, true);
    }, 150); // try 150, raise to 200 if you prefer

    function block(e){
      e.stopImmediatePropagation();
      relay();
    }

    // Capture phase so we beat theme and app listeners
    el.addEventListener('input', block, true);
  }

  init();
})();
